<template>
  <div class="background-page">
    <p class="background-name">背景分析</p>
    <div class="background-content-box">
      <div class="content-item" id="education"></div>
      <div class="content-item" id="work"></div>
      <div class="content-item" id="salary"></div>
    </div>
  </div>
</template>

<script>
  const chart = require('echarts');
  const typeColor = {
    '博士': 'rgba(244,244,244, 0.6)',
    '硕士': 'rgba(244,244,244, 0.7)',
    '不限学历': 'rgba(244,244,244, 0.8)',
    '大专及以下': 'rgba(244,244,244, 0.9)',
    '本科': 'rgba(244,244,244, 1)'
  }
  const formattingWorkYear = (year) => {
    if(typeof year != 'number'){
      year = Number(year)
    }
    if(year === 0){
      return '应届生'
    }else if(year === 1 || year === 2){
      return '1-3年'
    }else if(year === 3 || year === 4){
      return '3-5年'
    }else if(year > 5 && year < 10){
      return '5-10年'
    }else if(year > 10){
      return '10年以上'
    }
  }
  export default {
    name: "detail-background",
    props: {
      backgroundData: {
        type: Object,
        default: {
          education: {},
          workYear: {},
          level: {},
          edu_degree:"",
          work_year: "",
          position_level: ""
        }
      }
    },
    mounted() {
      setTimeout(()=>{
        this.educationChartInit()
        this.workChartInit()
        this.salaryChartInit()
      }, 200)
    },
    methods:{
      async educationChartInit(){
        let myChart = chart.init(document.querySelector("#education"));
        let data = Object.keys(this.backgroundData.education).map(item => {
          return {
            name: item,
            value: Number.isNaN(Number(this.backgroundData.education[item].replace('%', ''))) ? 0 : Math.floor(Number(this.backgroundData.education[item].replace('%', '')) * 100)
          }
        })
        // 绘制图表
        let option ={
          title: {
            text: '教育背景',
            left: 'center',
            textStyle:{
              fontSize: 18,
              color: "#fff",
              fontWeight: "500"
            },
            top: 30,
            left: 24
          },
          grid:{
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          series: [
            {
              type: 'pie',
              radius: '45%',
              top: 40,
              data,
              label:{
                color: "rgba(255, 255, 255, 0.6)",
                formatter: '{d}%\n{b}'
              },
              itemStyle: {
                color:  (params) => {
                  let {data: {name}} = params
                  return this.backgroundData.edu_degree != '' && this.backgroundData.edu_degree != null && (this.backgroundData.edu_degree === name || this.backgroundData.edu_degree.includes(name) || name.includes(this.backgroundData.edu_degree) )? 'rgba(255, 116, 96, 1)' : typeColor[name]
                }
              }
            }
          ]
        };
        myChart.setOption(option);
      },
      async workChartInit(){
        let myChart = chart.init(document.querySelector("#work"));
        // 绘制图表
        let option ={
          title: {
            text: '工作经验',
            left: 'center',
            textStyle:{
              fontSize: 18,
              color: "#fff",
              fontWeight: "500"
            },
            top: 30,
            left: 24
          },
          grid:{
            top: 100,
            bottom: 60,
            left: 74,
            right: 74
          },
          xAxis: {
            type: 'value',
            show: false
          },
          yAxis: [
            {
              type: 'category',
              data: ['10年以上','5-10年','3-5年','1-3年','应届生','不限经验'],
              axisLine: {
                show: false
              },
              axisTick : {
                show: false
              },
              axisLabel: {
                color: "rgba(255, 255, 255, 0.6)"
              }
            },
            {
              type: 'category',
              data: ['10年以上','5-10年','3-5年','1-3年','应届生','不限经验'].map(item => this.backgroundData.workYear[item]),
              axisTick : {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: "rgba(255, 255, 255, 1)"
              }
            }
          ],
          series: [
            {
              name: '',
              type: 'bar',
              data: ['10年以上','5-10年','3-5年','1-3年','应届生','不限经验'].map(item => Number.isNaN(Number(this.backgroundData.workYear[item].replace('%', ''))) ? 0 : Math.floor(Number(this.backgroundData.workYear[item].replace('%', '')) * 100)),
              showBackground: true,
              backgroundStyle: {
                borderRadius: 6,
                color: 'rgba(255, 255, 255, 0.1)'
              },
              barWidth: 12,
              itemStyle: {
                borderRadius: 6,
                color: (params) => {
                  let { name } = params
                  return this.backgroundData.work_year != null && formattingWorkYear(this.backgroundData.work_year) === name ? 'rgba(255, 116, 96, 1)' : 'rgba(244, 244, 244, 0.8)'
                }
              }
            }
          ]
        };
        myChart.setOption(option);
      },
      async salaryChartInit(){
        let myChart = chart.init(document.querySelector("#salary"));
        let levelType = {
          middle: "中级",
          senior: "总监专家",
          manager: "经理/资深",
          primary: "初级",
          advanced: "主管高级"
        }
        let keys = ["senior","manager","advanced","middle","primary"]
        // 绘制图表
        let option ={
          title: {
            text: '薪酬范围',
            left: 'center',
            textStyle:{
              fontSize: 18,
              color: "#fff",
              fontWeight: "500"
            },
            top: 30,
            left: 24
          },
          grid:{
            top: 100,
            bottom: 60,
            left: 74,
            right: 34
          },
          xAxis: {
            type: 'value',
            axisLine: {
              show: true
            },
            axisTick : {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(80, 85, 100, 1)"
              }
            }
          },
          yAxis: [
            {
              type: 'category',
              data: keys.map(item=>levelType[item]),
              axisLine: {
                show: true
              },
              axisTick : {
                show: false
              },
              axisLabel: {
                color: "rgba(255, 255, 255, 0.6)"
              }
            }
          ],
          series: [
            {
              type: 'bar',
              stack: '总量',
              itemStyle: {
                barBorderColor: 'rgba(0,0,0,0)',
                color: 'rgba(0,0,0,0)'
              },
              emphasis: {
                itemStyle: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
                }
              },
              data: keys.map(item=>{
                return Number(this.backgroundData.level[item]['annual_year_cash_dist_key']['25'])
              })
            },
            {
              name: '年总现金收入',
              type: 'bar',
              stack: '总量',
              data: keys.map(item=>{
                return Number(this.backgroundData.level[item]['annual_year_cash_dist_key']['75'])
              }),
              barWidth: 12,
              itemStyle: {
                barBorderRadius: 6,
                color: (param) => {
                  let {name} = param
                  return this.backgroundData.position_level != null && (name.includes(this.backgroundData.position_level) ||  this.backgroundData.position_level.includes(name) || this.backgroundData.position_level.includes(name.substr(0, 2)) || name.includes(this.backgroundData.position_level.substr(0, 2))) ? 'rgba(255, 116, 96, 1)' : 'rgba(244, 244, 244, 0.8)';
                }
              }
            }
          ]
        };
        myChart.setOption(option);
      }
    },
    watch:{
      'backgroundData.education'(value){
        if(JSON.stringify(value) != '{}'){
          this.educationChartInit()
        }
      },
      'backgroundData.workYear'(value){
        if(JSON.stringify(value) != '{}'){
          this.workChartInit()
        }
      },
      'backgroundData.level'(value){
        if(JSON.stringify(value) != '{}'){
          this.salaryChartInit()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.background-page{
  margin-bottom: 50px;
  .background-name{
    font-size: 32px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 45px;
    margin-bottom: 34px;
  }
  .background-content-box{
    width: 1200px;
    height: 454px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 12px;
    background-image: url("https://files.wondercv.com/PC/editor/planning/jobs/bgcard2.png");
    background-size: 100%;
    box-sizing: border-box;
    padding: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-item{
      width: 364px;
      height: 390px;
      background: #252830;
      border-radius: 8px;
    }
  }

}
</style>
